import { render, staticRenderFns } from "./CustomerReport.vue?vue&type=template&id=35f754de&scoped=true"
import script from "./CustomerReport.vue?vue&type=script&lang=js"
export * from "./CustomerReport.vue?vue&type=script&lang=js"
import style0 from "./CustomerReport.vue?vue&type=style&index=0&id=35f754de&prod&scoped=true&lang=css"
import style1 from "./CustomerReport.vue?vue&type=style&index=1&id=35f754de&prod&scoped=true&lang=css"
import style2 from "./CustomerReport.vue?vue&type=style&index=2&id=35f754de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f754de",
  null
  
)

export default component.exports